import { deriveAnonymousCurrentStep } from "./onboardingDraftStore";

export function resolveAnonymousEntry({ draft } = {}) {
  if (draft?.lastCompletedStep === 5 && draft.pendingGeneration) {
    return {
      destination: "/auth",
      currentStep: 5,
      reason: "ACCOUNT_GATE",
    };
  }

  const currentStep = deriveAnonymousCurrentStep(draft?.lastCompletedStep);
  return {
    destination: `/onboarding?step=${currentStep}`,
    currentStep,
    reason: draft ? "RESUME_ONBOARDING" : "START_ONBOARDING",
  };
}
